import "../../chunk-7QVYU63E.js";
var TeamRole = /* @__PURE__ */ function(TeamRole2) {
  TeamRole2["Admin"] = "admin";
  TeamRole2["Developer"] = "developer";
  TeamRole2["Viewer"] = "viewer";
  return TeamRole2;
}({});
export {
  TeamRole
};
//# sourceMappingURL=teamRole.js.map